import { cn } from "@gettactic/helpers/src/css/cn";
import { mergeRefs } from "@gettactic/helpers/src/dom/mergeRef";
import React from "react";
import { FormControlWrapper } from "../FormControlWrapper";
import { FormControlOutline } from "../FormControlWrapper/FormControlOutline";
import { useFormControlWrapper } from "../FormControlWrapper/FormControlWrapperProvider";
import {
  disabledCssClasses,
  disabledOutlineClasses
} from "../FormControlWrapper/defines";
import { splitFormControlWrapperProps } from "../FormControlWrapper/helpers";
import {
  NumberInputProps,
  NumberInputPropsWithFormControl
} from "./NumberInput.types";

export const NumberInputInput = React.forwardRef<
  HTMLInputElement,
  NumberInputProps
>((props, ref) => {
  const {
    inputClassName,
    className,
    disableOutline,
    unit,
    unitElement,
    ...rest
  } = props;
  const { id } = useFormControlWrapper();
  const inputRef = React.useRef<HTMLInputElement>(null);

  return (
    <div className="flex w-full items-center">
      <input
        {...rest}
        type="number"
        className={cn(
          "flex h-8 w-full border-0 bg-transparent text-sm shadow-none outline-none ring-0 transition-colors placeholder:text-muted-foreground",
          disabledCssClasses,
          disabledOutlineClasses,
          inputClassName,
          className
        )}
        style={{
          borderWidth: 0,
          outline: 0,
          border: 0,
          boxShadow: "none",
          ...rest.style
        }}
        ref={mergeRefs([ref, inputRef])}
        id={id}
      />
      {(unit || unitElement) && (
        <span className="pointer-events-none flex shrink-0 items-center px-2 text-sm font-medium text-neutral-500">
          {unitElement || unit}
        </span>
      )}
    </div>
  );
});

NumberInputInput.displayName = "NumberInputInput";

export const NumberInput = React.forwardRef<
  HTMLInputElement,
  NumberInputPropsWithFormControl
>((props, ref) => {
  const [wrapperProps, inputProps] = splitFormControlWrapperProps(props);

  return (
    <FormControlWrapper
      enableSlotsInputFocus
      {...wrapperProps}
      isDisabled={wrapperProps.isDisabled || inputProps.disabled}
    >
      <NumberInputInput ref={ref} {...inputProps} />
      {inputProps.disableOutline !== true && <FormControlOutline />}
    </FormControlWrapper>
  );
});

NumberInput.displayName = "NumberInput";
